import { render, staticRenderFns } from "./ListDoctor.vue?vue&type=template&id=c2df56f6&scoped=true&"
import script from "./ListDoctor.vue?vue&type=script&lang=ts&"
export * from "./ListDoctor.vue?vue&type=script&lang=ts&"
import style0 from "./ListDoctor.vue?vue&type=style&index=0&id=c2df56f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2df56f6",
  null
  
)

export default component.exports